import I18n from 'I18n';
import { getEnableAIDisclaimer } from './getEnableAIDisclaimer';
import { getSpamProtectionEnabled } from './getSpamProtectionEnabled';
export const getDisclaimerText = state => {
  const enableAI = getEnableAIDisclaimer(state);
  const spamProtection = getSpamProtectionEnabled(state);
  if (enableAI && spamProtection) {
    return I18n.text('conversations-visitor-experience-components.aiDisclaimerWithSpamProtection');
  } else if (enableAI) {
    return I18n.text('conversations-visitor-experience-components.aiDisclaimer');
  } else if (spamProtection) {
    return I18n.text('conversations-visitor-experience-components.spamProtectionEnabled');
  }
  return undefined;
};